/// <reference path="../../../typings/tsd.d.ts" /> 

module warsApp.controllers {
    export interface ISecurityMatrixScope extends angular.IScope {
        securityMatrix: Wars.Domain.Model.SecurityMatrix;
        processConfigurationId: string;
        close: any;
        dismissModal: any;
    }

    export class SecurityMatrixModalController extends BaseModalController {
        scope: ISecurityMatrixScope;

        constructor(
            scope: ISecurityMatrixScope,
            securityMatrix: Wars.Domain.Model.SecurityMatrix,
            processConfigurationId: string,
            close: any) {

            super(scope, close);
            this.scope = scope;

            this.scope.securityMatrix = securityMatrix;
            this.scope.processConfigurationId = processConfigurationId;
        }
    }
}

warsApp.registerController('SecurityMatrixModalController', [ '$scope', 'securityMatrix', 'processConfigurationId','close']);